/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import type {
  ActionFilterInput,
  ActionFilterByInput,
} from "~/generated/graphql";
import {
  ActionFilterByFields,
  FilterComparisonOperator,
} from "~/generated/graphql";
import { isNotEmpty } from "~/tools";
import { createFilterByInput } from "~/utils/createFilterByInput";
import { CustomActionQuery } from "~/views/customActions/types";

export const prepareCustomActionsFilterBy = (
  queryState: CustomActionQuery
): ActionFilterByInput[] => {
  const createdAtFilter = [
    {
      field: ActionFilterByFields.CreatedAt,
      operator: FilterComparisonOperator.Ge,
      values: [queryState.startDateUTC ?? ""],
    },
    {
      field: ActionFilterByFields.CreatedAt,
      operator: FilterComparisonOperator.Le,
      values: [queryState.endDateUTC ?? ""],
    },
  ].filter((filter) => isNotEmpty(filter.values[0]));

  const typesFilter = createFilterByInput<ActionFilterByFields>(
    ActionFilterByFields.Type,
    queryState.types ?? [],
    queryState.excludeTypes ?? false
  );

  const scopesFilter = createFilterByInput<ActionFilterByFields>(
    ActionFilterByFields.Scope,
    queryState.scopes ?? [],
    queryState.excludeScopes ?? false
  );

  const planIdsFilter = createFilterByInput<ActionFilterByFields>(
    ActionFilterByFields.PlanId,
    queryState.planIds ?? [],
    queryState.excludePlanIds ?? false
  );

  return [
    ...createdAtFilter,
    ...typesFilter,
    ...scopesFilter,
    ...planIdsFilter,
  ];
};

export const prepareCustomActionsFilter = (
  queryState: CustomActionQuery
): ActionFilterInput | undefined => {
  const filterBy = prepareCustomActionsFilterBy(queryState);
  const phrase = isNotEmpty(queryState.searchPhrase?.trim() || "")
    ? queryState.searchPhrase
    : undefined;
  const isFilterActive = isNotEmpty(filterBy) || isNotEmpty(phrase ?? "");

  if (!isFilterActive) {
    return undefined;
  }

  return {
    filterBy,
    phrase,
  };
};
